import strings from '../../Localization/Localization';

import {
  getAlphalinkClients,
  createAlphalinkAccount
} from '../../API/AlphalinkMVNO';

import {
  FLASHBAG_TYPE_SUCCESS,
  FLASHBAG_TYPE_DANGER
} from '../../Store/Action/flashbag';

let alphalinkId = {
  fieldKey: "alphalink_id",
  type: "dropdownEntity",
  label: strings.form.alphalinkClientAccount.alphalinkId.label,

  validators: [],
  assertObjectDefaultValue: true,

  loader: {
    id: "alphalinkAccounts",
    loader: getAlphalinkClients,
    loaderRequire: () => true,
    loaderArguments: () => [],
    dataTransformation: (response) => response.data
  },

  adapter: {
    requirement: (data) => data["idcustomer"] && data["company"],
    getValue: (data) => data["idcustomer"],
    getLabel: (data) => `${data["idcustomer"]} - ${data["company"]}`
  }
}

let alphalinkAccountCreation = {
  fieldKey: "alphalink_account_creation",
  type: "button",
  label: strings.form.alphalinkClientAccount.alphalinkAccountCreation.label,

  showOnDisabled: () => false,
  disabled: (getValues) => {
    if(!!(getValues(0)["alphalink_id"])) {
      return true;
    }
    return false;
  },

  as: 'request',
  request: {
    request: createAlphalinkAccount,
    requestRequire: () => true,
    requestArguments: (getValues) => [getValues().id],
    postRequestCallback: [
      {
        type: "flashbag",
        message: strings.form.alphalinkClientAccount.alphalinkAccountCreation.flashbagMessage,
        flashbagType: FLASHBAG_TYPE_SUCCESS,
      },
      {
        type: "reload"
      }
    ],
    postRequestCallbackFailure: [
      {
        type: "flashbag",
        message: strings.form.alphalinkClientAccount.alphalinkAccountCreation.flashbagMessageFailure,
        flashbagType: FLASHBAG_TYPE_DANGER,
      }
    ],
  },
}

export const form = {
  formKey: "alphalinkClientAccount",
  fields: [
    alphalinkId,
    alphalinkAccountCreation
  ]
}
